// Externe Bibliotheken
import React, { Component } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import { getDate, getParticipants, tripStartCountdown } from '@/_helper/bookingDetailsHelper';

class ExcursionItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.item.title ?? this.props.item.description.split(' -')[0],
            isOver: tripStartCountdown(this.props.item.startDate) === false && this.props.item.state !== 'XX',
            longDescription: this.props.item.description + ' ',
            truncated: false,
        };
        this.toggleTruncation = this.toggleTruncation.bind(this);
    }

    componentDidMount() {
        this.truncateText();
    }

    truncateText() {
        const limit = 200;

        if (this.props.item.description !== undefined) {
            if (this.props.item.state !== 'XX') {
                if (this.props.item.description.length > limit) {
                    const shortDescription = `${this.state.longDescription.substring(0, limit)} ... `;

                    this.setState({
                        shortDescription: shortDescription,
                        description: shortDescription,
                        truncated: true,
                    });
                } else {
                    this.setState({ description: this.state.longDescription });
                }
            }
        }
    }

    toggleTruncation() {
        if (this.state.truncated) {
            this.setState({
                truncated: false,
                description: this.state.longDescription,
            });
        } else {
            this.setState({
                truncated: true,
                description: this.state.shortDescription,
            });
        }
    }

    render() {
        return (
            <div
                className={`detail-item${this.props.item.state === 'XX' ? ' cancelled' : ''}${
                    this.state.isOver ? ' is-over' : ''
                }`}>
                <i className="material-symbols-outlined">attractions</i>
                <div>
                    <h4>
                        {this.state.title}
                        {this.props.item.state === 'XX' && <span className="chip storno"></span>}
                        {this.state.isOver && <span className="chip is-over"></span>}
                    </h4>
                    <div className="detail-item-body">
                        <div>
                            <div className={`image-sec${this.props.item.image === undefined ? ' no-image' : ''}`}>
                                {this.props.item.image !== undefined && (
                                    <LazyLoadImage
                                        wrapperClassName="lazy-load-background"
                                        src={this.props.item.image}
                                        alt={`Bild des Ausflugs "${this.props.item.title}"`}
                                        effect="blur"
                                    />
                                )}
                            </div>
                            {/*{ window.$browserInfo.device !== 'mobile' &&*/}
                            {/*    <Documents*/}
                            {/*        name="traveldocument"*/}
                            {/*        renderType="excursion"*/}
                            {/*        label="Ausflugsvoucher abrufen"*/}
                            {/*    />*/}
                            {/*}*/}
                        </div>

                        <div className="detail-item-content">
                            {this.state.description && this.props.item.title !== undefined && (
                                <div>
                                    <h4>Beschreibung</h4>
                                    <div className={`description${this.state.truncated ? ' truncated' : ''}`}>
                                        {this.state.description}
                                        {this.state.shortDescription && (
                                            <span className="show-more" onClick={this.toggleTruncation}>
                                                {this.state.truncated ? 'Mehr anzeigen' : 'Weniger anzeigen'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div>
                                <h4>Teilnehmende</h4>
                                {getParticipants(this.props.item)}
                            </div>
                            <div>
                                <h4>Datum</h4>
                                <div>{getDate(this.props.item)}</div>
                            </div>
                            {/*{ window.$browserInfo.device === 'mobile' &&*/}
                            {/*    <Documents*/}
                            {/*        name="traveldocument"*/}
                            {/*        renderType="excursion"*/}
                            {/*        label="Ausflugsvoucher abrufen"*/}
                            {/*    />*/}
                            {/*}*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExcursionItem;
